const MuiPaperOverrides = {
  MuiPaper: {
    defaultProps: {
      square: true,
      elevation: 0
    }
  }
};

export { MuiPaperOverrides };
